export const BACKEND_URI = process.env.NEXT_PUBLIC_BACKEND_URL || ''
export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT || 'local'
